<template>
    <div>
        <div class="max-w-6xl mx-auto px-4 py-8">
            <!-- LOADER -->
            <div v-if="loadingList" class="flex justify-center py-12">
                <div class="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
            </div>

            <!-- LISTE -->
            <div v-if="!loadingList" class="bg-white shadow rounded-xl overflow-hidden">

                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nom</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Droits</th>
                            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-gray-200">

                        <tr v-if="!techs.length">
                            <td colspan="4" class="px-6 py-6 text-center text-gray-500">
                                Aucun technicien
                            </td>
                        </tr>

                        <tr v-for="tech in techs" :key="tech.id" class="hover:bg-gray-50">

                            <td class="px-6 py-4">
                                <div class="font-medium">
                                    {{ tech.prenom }} {{ tech.nom }}
                                </div>
                            </td>

                            <td class="px-6 py-4 text-sm text-gray-600">
                                {{ tech.email }}
                            </td>

                            <td class="px-6 py-4 text-xs space-x-1">
                                <span v-if="tech.can_intervention" class="px-2 py-1 bg-blue-100 text-blue-700 rounded">Interv.</span>
                                <span v-if="tech.can_invoice" class="px-2 py-1 bg-red-100 text-red-700 rounded">Fact.</span>
                                <span v-if="tech.can_stats" class="px-2 py-1 bg-green-100 text-green-700 rounded">Stats</span>
                                <span v-if="tech.can_stock" class="px-2 py-1 bg-purple-100 text-purple-700 rounded">Stock</span>
                                <span v-if="tech.can_settings" class="px-2 py-1 bg-gray-200 text-gray-700 rounded">Settings</span>
                            </td>

                            <td class="px-6 py-4 space-x-2">

                                <button
                                    @click="editTech(tech)"
                                    class="px-3 py-1 text-xs bg-blue-600 text-white rounded"
                                >
                                    Modifier
                                </button>

                                <button
                                    @click="sendQr(tech)"
                                    class="px-3 py-1 text-xs bg-slate-600 text-white rounded"
                                >
                                    QR
                                </button>

                                <button
                                    @click="confirmDelete(tech)"
                                    class="px-3 py-1 text-xs bg-red-600 text-white rounded"
                                >
                                    Supprimer
                                </button>

                            </td>

                        </tr>
                    </tbody>
                </table>

            </div>

            <!-- MODAL EDIT -->
            <modal name="modal-edit-tech" width="800" height="auto" :adaptive="true">
                <div class="p-8" v-if="selectedTech">

                    <!-- HEADER -->
                    <div class="flex justify-between items-center mb-6 pb-4 border-b">
                        <div>
                            <h2 class="text-xl font-bold text-gray-800 flex items-center gap-2">
                                <i class="fas fa-user-edit text-blue-600"></i>
                                Modifier le technicien
                            </h2>
                            <p class="text-sm text-gray-500 mt-1">
                                Gérez les informations et permissions du compte.
                            </p>
                        </div>

                        <button @click="$modal.hide('modal-edit-tech')" class="text-gray-400 hover:text-red-600">
                            <i class="fas fa-times text-lg"></i>
                        </button>
                    </div>

                    <!-- INFOS -->
                    <div class="bg-white rounded-xl border p-6 mb-6">
                        <h3 class="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
                            <i class="fas fa-id-card text-gray-400"></i>
                            Informations générales
                        </h3>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

                            <div>
                                <label class="text-sm text-gray-600">Prénom</label>
                                <div class="relative mt-1">
                                    <i class="fas fa-user absolute left-3 top-3 text-gray-400"></i>
                                    <input v-model="selectedTech.prenom"
                                        class="pl-10 w-full rounded-lg border border-gray-300 py-2 text-sm focus:ring-2 focus:ring-blue-500">
                                </div>
                            </div>

                            <div>
                                <label class="text-sm text-gray-600">Nom</label>
                                <div class="relative mt-1">
                                    <i class="fas fa-user absolute left-3 top-3 text-gray-400"></i>
                                    <input v-model="selectedTech.nom"
                                        class="pl-10 w-full rounded-lg border border-gray-300 py-2 text-sm focus:ring-2 focus:ring-blue-500">
                                </div>
                            </div>

                            <div class="col-span-2">
                                <label class="text-sm text-gray-600">Email</label>
                                <div class="relative mt-1">
                                    <i class="fas fa-envelope absolute left-3 top-3 text-gray-400"></i>
                                    <input v-model="selectedTech.email"
                                        class="pl-10 w-full rounded-lg border border-gray-300 py-2 text-sm focus:ring-2 focus:ring-blue-500">
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- PERMISSIONS -->
                    <div class="bg-white rounded-xl border p-6">
                        <h3 class="text-sm font-semibold text-gray-700 mb-4 flex items-center gap-2">
                            <i class="fas fa-user-shield text-gray-400"></i>
                            Droits & permissions
                        </h3>

                        <div class="space-y-3">

                            <div
                                v-for="permission in permissions"
                                :key="permission.key"
                                class="flex items-center justify-between p-4 rounded-lg border transition"
                                :class="selectedTech[permission.key] ? permission.activeClass : 'bg-gray-50 border-gray-200'"
                            >
                                <div class="flex items-start gap-3">
                                    <i :class="permission.icon + ' mt-1 ' + permission.iconColor"></i>
                                    <div>
                                        <p class="text-sm font-medium text-gray-800">
                                            {{ permission.label }}
                                        </p>
                                        <p class="text-xs text-gray-500">
                                            {{ permission.description }}
                                        </p>
                                    </div>
                                </div>

                                <button
                                    @click="selectedTech[permission.key] = !selectedTech[permission.key]"
                                    class="relative inline-flex h-6 w-11 items-center rounded-full transition"
                                    :class="selectedTech[permission.key] ? permission.toggleClass : 'bg-gray-300'"
                                >
                                    <span
                                        class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                                        :class="selectedTech[permission.key] ? 'translate-x-6' : 'translate-x-1'"
                                    ></span>
                                </button>
                            </div>

                        </div>
                    </div>

                    <!-- ACTIONS -->
                    <div class="flex justify-end gap-3 mt-8">

                        <button
                            @click="$modal.hide('modal-edit-tech')"
                            class="px-5 py-2 bg-gray-200 hover:bg-gray-300 text-sm rounded-lg transition"
                        >
                            Annuler
                        </button>

                        <button
                            @click="saveTech"
                            class="px-6 py-2 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white text-sm rounded-lg shadow-md transition"
                        >
                            <i class="fas fa-check mr-2"></i>
                            Enregistrer
                        </button>

                    </div>

                </div>
            </modal>


            <!-- CONFIRM DELETE -->
            <modal name="modal-delete-tech" width="450" height="auto" :adaptive="true">
                <div class="p-6">
                    <div class="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-100 rounded-full">
                        <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>
                    </div>

                    <h3 class="text-lg font-semibold text-center text-gray-900 mb-2">
                        Supprimer le technicien
                    </h3>

                    <p class="text-center text-gray-600 mb-6">
                        <span class="font-medium text-gray-900">{{ selectedTech?.prenom }} {{ selectedTech?.nom }}</span> ?
                        <br>
                        <span class="text-sm text-red-600">Cette action est irréversible.</span>
                    </p>

                    <div class="flex justify-end space-x-3">
                        <button 
                            @click="$modal.hide('modal-delete-tech')" 
                            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition"
                        >
                            Annuler
                        </button>
                        <button 
                            @click="deleteTech" 
                            class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition"
                        >
                            Supprimer définitivement
                        </button>
                    </div>
                </div>
            </modal>

        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            societeId: this.$route.params.id,
            techs: [],
            selectedTech: null,
            loadingList: false,

            permissions: [
                {
                    key: 'can_intervention',
                    label: 'Interventions',
                    description: 'Créer et gérer des interventions.',
                    icon: 'fas fa-tools',
                    iconColor: 'text-blue-500',
                    activeClass: 'bg-blue-50 border-blue-400',
                    toggleClass: 'bg-blue-600'
                },
                {
                    key: 'can_invoice',
                    label: 'Facturation',
                    description: 'Créer et valider des factures.',
                    icon: 'fas fa-file-invoice',
                    iconColor: 'text-red-500',
                    activeClass: 'bg-red-50 border-red-400',
                    toggleClass: 'bg-red-600'
                },
                {
                    key: 'can_stats',
                    label: 'Statistiques',
                    description: 'Accès aux indicateurs et performances.',
                    icon: 'fas fa-chart-line',
                    iconColor: 'text-green-500',
                    activeClass: 'bg-green-50 border-green-400',
                    toggleClass: 'bg-green-600'
                },
                {
                    key: 'can_stock',
                    label: 'Stock',
                    description: 'Gestion du stock et des pièces.',
                    icon: 'fas fa-box',
                    iconColor: 'text-purple-500',
                    activeClass: 'bg-purple-50 border-purple-400',
                    toggleClass: 'bg-purple-600'
                },
                {
                    key: 'can_settings',
                    label: 'Paramètres',
                    description: 'Accès aux réglages avancés.',
                    icon: 'fas fa-cog',
                    iconColor: 'text-gray-600',
                    activeClass: 'bg-gray-100 border-gray-400',
                    toggleClass: 'bg-gray-700'
                }
            ]

        }
    },

    mounted() {
        this.loadTechs()
    },

    methods: {

        async loadTechs() {
            this.loadingList = true

            let res = await this.$request.post('/admin/societes/tech-list', {
                societe_id: this.societeId
            })

            this.techs = res

            this.loadingList = false
        },

        editTech(tech) {
            this.selectedTech = { ...tech }
            this.$modal.show('modal-edit-tech')
        },

        async saveTech() {
            await this.$request.post('/admin/societes/tech-update', {
                user_id: this.selectedTech.id,
                ...this.selectedTech
            })

            this.$toast.success('Technicien mis à jour')
            this.$modal.hide('modal-edit-tech')
            this.loadTechs()
        },

        confirmDelete(tech) {
            this.selectedTech = tech
            this.$modal.show('modal-delete-tech')
        },

        async deleteTech() {
            await this.$request.post('/admin/societes/tech-delete', {
                user_id: this.selectedTech.id
            })

            this.$toast.success('Technicien supprimé')
            this.$modal.hide('modal-delete-tech')
            this.loadTechs()
        },

        async sendQr(tech) {
            if (confirm(`Envoyer le lien de connexion à ${tech.prenom} ${tech.nom} ?`)) {
                await this.$request.post('/admin/societes/tech-send-qrcode', {
                    user_id: tech.id
                })

                this.$toast.success('Lien de connexion envoyé')
            }
        }
    }
}
</script>
